import React from 'react';
import {Link} from 'react-router-dom';
import rs from '../../config/router';
import './Footer.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="wrapper">
        <ul className="footer__menu">
          <li className="footer__menu-item">
            <Link to={rs.aboutUs}>
              About us
            </Link>
          </li>
          <li className="footer__menu-item">
            <Link to={rs.contactUs}>
              Contact us
            </Link>
          </li>
        </ul>
      </div>
    </footer>
  )
}

export default Footer;


// WEBPACK FOOTER //
// ./src/app/containers/Footer/index.js